import { useState } from 'react';
import type { NavigationAdapter } from './types';

/**
 * Browser native navigation adapter
 * Uses browser's native URLSearchParams and <a> tags
 * Suitable for vanilla React apps without a routing library
 */
export const BrowserNavigationAdapter: NavigationAdapter = {
  /**
   * Returns URLSearchParams from current window.location.search
   * Note: Not reactive - reads once on component mount
   * This is sufficient for auth flows where we read initial URL params
   */
  useSearchParams() {
    const [searchParams] = useState(() => {
      if (typeof window === 'undefined') {
        return new URLSearchParams();
      }
      return new URLSearchParams(window.location.search);
    });

    return searchParams;
  },

  /**
   * Native <a> tag for navigation
   * Uses full page reload
   */
  Link({ href, className, children }) {
    return (
      <a href={href} className={className}>
        {children}
      </a>
    );
  },
};
